const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const program = () => import(/* webpackPrefetch: true */ '@/views/private/program/index.vue')
const program_detail = () => import(/* webpackPrefetch: true */ '@/views/private/program/_id.vue')
const program_add = () => import(/* webpackPrefetch: true */ '@/views/private/program/add/index.vue')
const program_edit = () => import(/* webpackPrefetch: true */ '@/views/private/program/edit/_id.vue')
const program_edit_realisasi = () => import(/* webpackPrefetch: true */ '@/views/private/program/realisasi/_id.vue')

const laporan_perkembangan = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/perkembangan/index.vue')
const laporan_rekapitulasi = () => import(/* webpackPrefetch: true */ '@/views/private/laporan/rekapitulasi/index.vue')

const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },


  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },


  {
    path: "/program",
    name: "Program",
    component: program,
    meta: {
      title: "Program"
    }
  },
  {
    path: "/program/detail/:id",
    name: "Detail Program",
    component: program_detail,
    meta: {
      title: "Detail Program"
    }
  },
  {
    path: "/program/add",
    name: "Tambah Program",
    component: program_add,
    meta: {
      title: "Tambah Program"
    }
  },
  {
    path: "/program/edit/:id",
    name: "Ubah Program",
    component: program_edit,
    meta: {
      title: "Ubah Program"
    }
  },
  {
    path: "/program/edit/realisasi/:id",
    name: "Ubah Realisasi Fisik",
    component: program_edit_realisasi,
    meta: {
      title: "Ubah Realisasi Fisik"
    }
  },


  {
    path: "/laporan/perkembangan",
    name: "Laporan Perkembangan Fisik Dan Keuangan",
    component: laporan_perkembangan,
    meta: {
      title: "Laporan Perkembangan Fisik Dan Keuangan"
    }
  },
  {
    path: "/laporan/rekapitulasi",
    name: "Laporan Rekapitulasi",
    component: laporan_rekapitulasi,
    meta: {
      title: "Laporan Rekapitulasi"
    }
  },


  {
    path: "/user",
    name: "Pegawai",
    component: user,
    meta: {
      title: "Pegawai"
    }
  },
  {
    path: "/user/detail/:id",
    name: "Detail Pegawai",
    component: user_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },
  {
    path: "/user/add",
    name: "Tambah Pegawai",
    component: user_add,
    meta: {
      title: "Tambah Pegawai"
    }
  },
  {
    path: "/user/edit/:id",
    name: "Ubah Pegawai",
    component: user_edit,
    meta: {
      title: "Ubah Pegawai"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})